import { render, staticRenderFns } from "./boolean-service-config-field.component.vue?vue&type=template&id=6e765e3e&scoped=true"
import script from "./boolean-service-config-field.component.vue?vue&type=script&lang=ts"
export * from "./boolean-service-config-field.component.vue?vue&type=script&lang=ts"
import style0 from "./boolean-service-config-field.component.vue?vue&type=style&index=0&id=6e765e3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e765e3e",
  null
  
)

export default component.exports